import styled from "styled-components";
import { TextS } from "../../common/text";

export const ContentInfo = styled(TextS)`
  white-space: pre-wrap;
`;
